<template>
  <div>
    <template v-if="isEditing || isCreating">
      <div class="category-item form">
        <img
          class="folder-icon"
          src="/image/folder/ing.png"
        >
        <input
          ref="inputCategoryName"
          v-model="form.name"
          type="text"
          placeholder="카테고리명 입력"
        >
        <div class="category-item-control">
          <button
            class="cancel"
            style="margin-left: 0;"
            @click="cancelEditingMode"
          >
            취소
          </button>
          <button
            class="confirm"
            @click="handleClickSaveForm"
          >
            확인
          </button>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="category-item view"
        :class="{active: isActive}"
        @click="handleClickItem"
      >
        <img
          class="folder-icon"
          src="/image/folder/normal.png"
        >
        <span>{{ name }}</span>
        <div
          v-if="isActive"
          class="category-item-control"
        >
          <button
            class="cancel"
            @click.stop="setEditingMode"
          >
            수정
          </button>
          <button
            class="confirm"
            @click="handleClickDelete"
          >
            삭제
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { computedGetters } from "@/utils/vuex-helper";
  import { fiflboxApi } from '@/utils/api';

  export default {
    name: "CategoryItem",
    props: {
      id: {
        type: Number,
        default: null
      },
      name: {
        type: String
      },
      isActive: {
        type: Boolean
      },
      isCreating: {
        type: Boolean
      }
    },
    data() {
      return {
        form: {
          id: null,
          name: "",
        },
        isEditing: false
      };
    },
    watch: {
      isActive(value) {
        if (!value) {
          this.isEditing = false
        }
      }
    },
    computed: {
      ...computedGetters(['parentMembershipCategories'])
    },
    methods: {
      async handleClickSaveForm() {
        if (this.id) {
          await this.updateCategory(this.form);
          return this.cancelEditingMode();
        }

        this.createCategory(this.form);
      },
      async handleClickDelete() {
        if (this.parentMembershipCategories.length <= 1) {
          return this.$alert(
            "적어도 하나 이상 카테고리가 필요하여 삭제가 불가합니다.",
            "기본 카테고리를 삭제 중입니다."
          );
        }

        const category = this.parentMembershipCategories
          .find(category => category.id === this.id)

        if (category.parent_memberships.length > 0) {
          try {
            await this.$confirm(
              "카테고리 내 회원권을 먼저 삭제해주시길 바랍니다.",
              "카테고리 삭제 보류",
              {
                confirmButtonText: "확인",
                cancelButtonText: "모든 회원권 삭제"
              }
            );

            return;
          } catch (err) {
          }
        }

        this.deleteCategory(this.id);
      },
      setEditingMode() {
        if (this.id) {
          this.form.id = this.id;
          this.form.name = this.name;
        }

        this.isEditing = true
        this.$nextTick(() => {
          this.$refs["inputCategoryName"].focus();
        })
      },
      cancelEditingMode() {
        this.isEditing = false
        this.$emit("closeCreateForm");
      },
      handleClickItem() {
        this.$emit("select", this.id);
      },
      async createCategory(form) {
        try {
          await fiflboxApi.v2.postMembershipCategories(form);
          await this.$store.dispatch("syncParentMembershipCategories");
          this.$emit("closeCreateForm");
        } catch (err) {

        }
      },
      async updateCategory(form) {
        try {
          await fiflboxApi.v2.putMembershipCategories(form.id, form);
          await this.$store.dispatch("syncParentMembershipCategories");
        } catch (err) {

        }
      },
      async deleteCategory(categoryId) {
        try {
          await fiflboxApi.v2.deleteMembershipCategories(categoryId);

          this.$emit("delete");
        } catch (err) {

        }
      },
    },
  };
</script>

<style lang="scss">
  .category-item-control {
    flex: initial;

    button {
      background-color: transparent;
      font-size: 11px;
      padding: 0 1px;
      line-height: 20px;
      letter-spacing: -0.6px;
      color: #ffffff;
      border: 0;
      margin-left: 10px;

      &.edit {
        color: white;
      }

      &.delete {
        color: #4a4a4a;
      }

      &.cancel {
        color: #d3d3d3;
      }

      &.confirm {
        color: #4a4a4a;
      }

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }

      &:focus {
        outline: none;
      }
    }
  }
</style>
